var imageCallout = $(".imageCalloutWrapper"),
    calloutVideo = imageCallout.find("video"),
    playPauseBtn = imageCallout.find(".btn.playVidBtn");
    
var destTranform = "translateX(800px)",
    origTransform = "translateX(0px)";

function setTransformDirection(){
    "use strict";

    if(window.innerWidth <= 992){
        destTranform = "translateY(800px)";
        origTransform = "translateY(0px)";
    } else {
        destTranform = "translateX(800px)",
        origTransform = "translateX(0px)";
    }
}

/* slide angle to right or bottom depending on window size, fadeOut featured badge,
    and hide poster image and play video */
imageCallout.find("#startVideo").on("click", function(){
    var winSize = window.outerWidth;

    setTransformDirection();

    $(".featured-item").fadeOut();
    $(".imageCalloutWrapper .bgShape, .imageCalloutWrapper .copy.right").css("transform", destTranform);
    
    // remove the bg from the marquee so the video can be on a white background
    imageCallout.find("img.mainImg").css("opacity", 0);
    $(".imageCalloutWrapper, .imageCalloutWrapper > .right").css("background", "white");

    imageCallout.find("video").fadeIn();
    calloutVideo[0].play();
    calloutVideo[0].addEventListener("ended", videoStoppedPlaying, false);
    imageCallout.addClass("video-playing");
    
    playPauseBtn.removeClass("play").addClass("pause");
    playPauseBtn.find("i").removeClass("fa-play").addClass("fa-pause");

    // if video is playing and width is less than or equal to 992px
    // then make the height of the video the height of the imageCallout
    // storing the original height to restore to after the video is done playing
    if(imageCallout.hasClass("video-playing") && window.innerWidth <= 992){
        var origCalloutHeight = imageCallout.height(),
            vidHeight = calloutVideo.height();
        
        imageCallout.attr("data-orig-height", origCalloutHeight);
        imageCallout.animate({height: vidHeight});
    }

    return false;
});

/* Runs when the HTML5 video's "ended" event is triggered.
    More specifically, when .imageCalloutWrapper video ends we're going to fade it out,
    transform the diagonal back to its original position and fade in the featured item div */
function videoStoppedPlaying(e){
  var vid = this,
      $this = jQuery(e.target),
      origCalloutHeight = parseInt(imageCallout.attr("data-orig-height"));

  // wait 1s before overlaying play button again
  setTimeout(function(){

   stopTheVideo(vid);

  }, 1000);
}

/**
 * Stops the video, sets it back to the beginning and puts the video marquee contents back
 * this function exists to maintain the DRY principle between the video end event and the 
 * video close button
 * 
 * @param vid the HTML video element
 */
function stopTheVideo(vid) {
    var origCalloutHeight = parseInt(imageCallout.attr("data-orig-height"));

    // set video back to beginning
    vid.load();
    
    // fade out the video, fade in the featured item and transform the slide angle back to its original angle
    playPauseBtn.find("i").removeClass("fa-pause").addClass("fa-play");    
    playPauseBtn.removeClass("pause").addClass("play");   

    imageCallout.removeClass("video-playing");
    calloutVideo.fadeOut();
    imageCallout.css("height", origCalloutHeight);
    imageCallout.removeAttr("data-orig-height");
    imageCallout.removeAttr("style");

    // add the bg from the marquee back before putting the marquee contents back
    var origBackgroundURL = $(".imageCalloutWrapper > .right[data-bg]").attr("data-bg");
        
    imageCallout.find("img.mainImg").css("opacity", 1);
    imageCallout.find(".col-md-10.right").css("background", "url(" + origBackgroundURL + ");");
    imageCallout.find(".copy.right").css("background", "none");
    imageCallout.css("background", "#25ccd4");
    
    $(".imageCalloutWrapper .bgShape, .imageCalloutWrapper .copy.right").css("transform", origTransform);
    
    if(window.innerWidth > 992){
        $(".featured-item").fadeIn();
    }
}

$(window).on("resize", function(){

    // change the angle of the slide angle
    setTransformDirection();

    // if video is playing and width is less than or equal to 992px
    // then make the height of the video the height of the imageCallout
    // storing the original height to restore to after the video is done playing
    if(imageCallout.hasClass("video-playing") && window.innerWidth <= 992){
        var origCalloutHeight = imageCallout.height(),
            vidHeight = calloutVideo.height();
        
        imageCallout.attr("data-orig-height", origCalloutHeight);
        imageCallout.css("height", vidHeight);
    }

    if(imageCallout.hasClass("video-playing")){
       if(window.innerWidth > 992){
            $(".featured-item").hide();
       }
    } else {
         if(window.innerWidth > 992){
            $(".featured-item").show();
        } else {
            $(".featured-item").hide();
        }
    }
});

$("#vidControls").on("click", function(e){
   
    if($(this).hasClass("play")){
        calloutVideo[0].play();
        playPauseBtn.find("i").removeClass("fa-play").addClass("fa-pause");       
        $("a.btn.playVidBtn").removeClass("play").addClass("pause");
    } else {
        calloutVideo[0].pause(); 
        playPauseBtn.find("i").removeClass("fa-pause").addClass("fa-play");
        $("a.btn.playVidBtn").removeClass("pause").addClass("play");
    }

    return false;
});

/* When the user clicks the "X" button, first pause the video, then stop the video
   and return the video marquee contents to their original state */
$("#closeVidBtn").on("click", function(e){

    calloutVideo[0].pause(); 
    playPauseBtn.find("i").removeClass("fa-pause").addClass("fa-play");
    $("a.btn.playVidBtn").removeClass("pause").addClass("play");

    stopTheVideo(calloutVideo[0]);

    return false;
});